import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IntranetApiResponse, IntranetUiResponse } from '../models/intranet-maestro';
import { WebService } from './webservices.service';

export type EstadoCampo = 'OCULTO' | 'OPCIONAL' | 'OBLIGATORIO';

export interface CampoVehiculoConfig {
  idCampo: number;
  codigo: string;
  descripcion: string;
  tipoControl: string;
  seccion: number;
  estado: EstadoCampo;
  orden: number;
  activo: number;
}

export interface CampoVehiculoGlobal {
  idCampo: number;
  codigo: string;
  descripcion: string;
  tipoControl: string;
  seccion: number;
  orden: number;
  activo: number;
}

@Injectable({ providedIn: 'root' })
export class IntranetVehiculoCamposService {
  private readonly url = `${environment.URL_WEBSERVICES}/intranet/seguridad/mantenedores/vehiculo-campos`;

  constructor(private readonly webService: WebService) {}

  obtener(idTipoVehiculo: number): Observable<IntranetUiResponse<CampoVehiculoConfig[]>> {
    return this.post<CampoVehiculoConfig[]>('obtener', { idTipoVehiculo });
  }

  guardar(idTipoVehiculo: number, campos: CampoVehiculoConfig[]): Observable<IntranetUiResponse<null>> {
    return this.post<null>('guardar', {
      idTipoVehiculo,
      campos: campos
        .filter((campo) => Number(campo.activo) === 1)
        .map(({ idCampo, estado, orden }) => ({ idCampo, estado, orden })),
    });
  }

  listarGlobal(): Observable<IntranetUiResponse<CampoVehiculoGlobal[]>> {
    return this.post<CampoVehiculoGlobal[]>('global/listar', {});
  }

  cambiarVisibilidadGlobal(idCampo: number, activo: number): Observable<IntranetUiResponse<null>> {
    return this.post<null>('global/visibilidad', { idCampo, activo });
  }

  private post<T>(accion: string, body: unknown): Observable<IntranetUiResponse<T>> {
    return this.webService.peticionPost(`${this.url}/${accion}`, body, true).pipe(
      map((response) => {
        const data = response as IntranetApiResponse<T>;
        return {
          isSuccess: data.success ?? data.isSuccess ?? false,
          message: data.message ?? '',
          value: (data.data ?? data.value ?? null) as T | null,
        };
      }),
    );
  }
}
